import React from 'react'

import useConversationActions from 'conversations/hooks/useConversationActions'

import { IconButton } from '@driftt/dds'
import { faCircleXmark } from '@driftt/dds.icons/light/faCircleXmark'

interface Props {
  conversationId: number
}

const ConversationCloseButton: React.FC<Props> = ({ conversationId }): JSX.Element | null => {
  const { closeConversation } = useConversationActions(conversationId)

  return (
    <IconButton
      title="Close"
      data-ocweb-id="ConversationInactiveX"
      onClick={closeConversation}
      variant="tertiary"
      icon={faCircleXmark}
      iconVariant="gray"
    />
  )
}

export default ConversationCloseButton
